import styled from 'styled-components'
import { rem } from 'polished'

export const StyledFeaturedMedia = styled.figure`
  grid-area: media;
  margin: 0;
  margin-bottom: ${rem(14)};
`
